export { default } from './CtaPair';
